import { useMutation } from '@tanstack/react-query';

import type {
  BookingStaffAnnotationMutationResponse,
  CreateBookingStaffAnnotationData,
  UpdateBookingStaffAnnotationData,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateBookingStaffAnnotationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: CreateBookingStaffAnnotationData;
    }) =>
      HttpClient.request<BookingStaffAnnotationMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { staff_annotation: params.data },
      }),
  });

export const useUpdateBookingStaffAnnotationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: UpdateBookingStaffAnnotationData;
    }) =>
      HttpClient.request<BookingStaffAnnotationMutationResponse>({
        method: 'PUT',
        url: params.url,
        data: { staff_annotation: params.data },
      }),
  });

export const useDeleteBookingStaffAnnotationMutation = () =>
  useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<BookingStaffAnnotationMutationResponse>({
        method: 'DELETE',
        url,
      }),
  });
